import { useCallback, useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { fetchExperienceAnswers, fetchExperienceWaivers } from "store/reservations"

const EMPTY_EXTRAS = { waivers: [], answers: [] }

// One experience's waivers and answers in an order, loaded the first time its accordion opens
// (`isEnabled`) and kept apart from the other experiences'. Its payments are in the reservation's
// one Payments panel (useOrderPaymentHistory).
export const useExperienceExtras = (uuid, isEnabled) => {
  const dispatch = useDispatch()
  const [extras, setExtras] = useState(EMPTY_EXTRAS)
  const [isLoading, setIsLoading] = useState(false)
  const [isFailed, setIsFailed] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)

  const reload = useCallback(async () => {
    setIsLoading(true)
    setIsFailed(false)
    const [waivers, answers] = await Promise.allSettled([dispatch(fetchExperienceWaivers(uuid)), dispatch(fetchExperienceAnswers(uuid))])
    setExtras((prev) => ({
      waivers: waivers.status === "fulfilled" ? waivers.value : prev.waivers,
      answers: answers.status === "fulfilled" ? answers.value : prev.answers
    }))
    setIsFailed([waivers, answers].some((result) => result.status === "rejected"))
    setIsLoading(false)
    setIsLoaded(true)
  }, [dispatch, uuid])

  useEffect(() => {
    if (isEnabled && !isLoaded && !isLoading) reload()
  }, [isEnabled, isLoaded, isLoading, reload])

  return { ...extras, isLoading, isFailed, reload }
}
